import { useSuspenseQuery } from '@tanstack/react-query'
import { useTRPC } from '~/services/trpc'

window.HAP_CURRENT_ORGANIZATION_LEGACY_ID = ''

const useCurrentOrganization = () => {
  const trpc = useTRPC()
  const { data: org } = useSuspenseQuery(
    trpc.organizations.getCurrentOrg.queryOptions(undefined, {
      staleTime: 60 * 60 * 1000, // 1 hour
    }),
  )
  if (!org) throw new Error('Error fetching current org')
  window.HAP_CURRENT_ORGANIZATION_LEGACY_ID = org.id
  return org
}

export default useCurrentOrganization
